import { useState } from 'react';
import './App.css';
import Home from './Home';
import Header from './Header';
import Footer from './Footer';
import AboutPage from './AboutPage';
import CareerPage from './CareerPage';

function App() {
  const [page, setPage] = useState('home');
  const [isContactOpen, setIsContactOpen] = useState(false);

  const scrollToSection = (sectionId) => {
    setTimeout(() => {
      const target = document.getElementById(sectionId);
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    }, 50);
  };

  const handleNavigation = (target) => {
    if (target === 'contact') {
      setIsContactOpen(true);
      return;
    }

    if (target === 'about') {
      setPage('about');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (target === 'career') {
      setPage('career');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (target === 'top') {
      setPage('home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    setPage('home');
    scrollToSection(target);
  };

  return (
    <div className='App-shell'>
      <Header onNavigate={handleNavigation} />

      {page === 'home' && <Home onNavigate={handleNavigation} />}
      {page === 'about' && <AboutPage />}
      {page === 'career' && <CareerPage />}

      {isContactOpen && (
        <div className='modalBackdrop' onClick={() => setIsContactOpen(false)}>
          <div className='contactModal' onClick={(event) => event.stopPropagation()}>
            <button type='button' className='closeButton' onClick={() => setIsContactOpen(false)}>
              ×
            </button>
            <span className='eyebrow'>Contact</span>
            <h2>Get in touch</h2>
            <ul className='contactList'>
              <li>
                <strong>Address:</strong> 45 Innovation Avenue, Lekki Phase 1, Lagos, Nigeria
              </li>
              <li>
                <strong>Email:</strong> hello@viewjot.com
              </li>
              <li>
                <strong>Phone:</strong> +234 800 123 4567
              </li>
            </ul>
          </div>
        </div>
      )}

      <Footer onNavigate={handleNavigation} />
    </div>
  );
}

export default App;
